import { i18n } from '#react/i18n/create'

export const authMessageDefaults = {
  appName: 'Canvas',
  welcomeBack: 'Welcome Back',
  loginSubtitle: 'Sign in to your account',
  usernameOrEmail: 'Email',
  usernameOrEmailPlaceholder: 'Enter your email',
  password: 'Password',
  passwordPlaceholder: 'Enter your password',
  rememberMe: 'Remember me',
  forgotPassword: 'Forgot password?',
  signIn: 'Sign In',
  loggingIn: 'Logging in...',
  noAccount: "Don't have an account?",
  signUp: 'Sign Up',
  createAccount: 'Create an account',
  registerSubtitle: 'Register with email, then enter the verification code',
  username: 'Username',
  name: 'Nickname',
  email: 'Email',
  confirmPassword: 'Confirm password',
  creatingAccount: 'Creating account...',
  hasAccount: 'Already have an account?',
  continueWithGithub: 'Continue with GitHub',
  continueWithGoogle: 'Continue with Google',
  orEmail: 'or email',
  verifyEmail: 'Verify your email',
  verifySubtitle: 'Enter the 6-digit code we sent you',
  verificationCode: 'Verification code',
  verifyAndSignIn: 'Verify and sign in',
  verifying: 'Verifying...',
  resendCode: 'Resend code',
  backToSignIn: 'Back to sign in',
  enterVerificationCode: 'Enter verification code',
  invalidCode: 'Enter your email and the 6-digit code',
  emailRequired: 'Enter your email first',
  codeSent: 'If this account needs verification, a new code was sent',
  signingIn: 'Signing in',
  oauthWait: 'Finishing sign in…',
  oauthUnlinked:
    'This GitHub or Google account is not linked yet. Register first, then click GitHub or Google again to link it.',
  logOut: 'Log out',
  backToFileList: 'Back to files'
} as const

export const authMessages = i18n('auth', authMessageDefaults)
